import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["provider", "onShare"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import LinkedInModal from './linkedin-modal';
import TwitterModal from './twitter-modal';
import { jsx as _jsx } from "react/jsx-runtime";
export var validateCharCount = function validateCharCount(minimumCharacters) {
  return function (internalMessage) {
    return !minimumCharacters || internalMessage.length >= minimumCharacters;
  };
};

var ShareModal = function ShareModal(_ref) {
  var provider = _ref.provider,
      onShare = _ref.onShare,
      props = _objectWithoutProperties(_ref, _excluded);

  switch (provider) {
    case 'twitter':
      return /*#__PURE__*/_jsx(TwitterModal, _objectSpread({
        onShare: onShare(provider)
      }, props));

    case 'linkedin':
      return /*#__PURE__*/_jsx(LinkedInModal, _objectSpread({
        onShare: onShare(provider)
      }, props));

    default:
      return null;
  }
};

export default ShareModal;